import React from "react";
import _ from "lodash";
import TrendUprImpression from "./TrendUprImpression";
import NumberFormat from "../../common/NumberFormat";
import { getWeekdayAbbr } from "../../../helpers/DateTransform";
import { transformGamUprToUprConfig } from "components/network/pricing-rules/gam-upr/GamUprHelper";
import UprTargetingPopover from "components/ops-mgmt/account/custom-upr/UprTargetingPopover";
import UprPriceSection from "components/network/pricing-rules/gam-upr/UprPriceSection";
import HighLightRowWrapper from "components/common/HighLightRowWrapper";

class UprValidationView extends React.PureComponent {
  constructor(props) {
    super(props);

    let publisherReports = _.clone(props.reportsByRules);
    const intowowReports = _.remove(publisherReports, (r) => {
      return _.includes(_.lowerCase(r.name), "intowow");
    });

    const intowowReportsByDate = _.groupBy(intowowReports, "date");
    const uprValidationReports = _(props.reports)
      .map((r) => {
        const intowowReport = _.get(intowowReportsByDate, [r.date, 0], {});
        r.revenue = intowowReport.revenue;
        r.ecpm = intowowReport.ecpm;
        return r;
      })
      .orderBy(props.reports, ["date"], ["desc"])
      .value();

    this.state = {
      uprValidationReports,
      intowowReports,
      publisherReports: publisherReports.map((r) => {
        const upr = _.find(props.uprs, { externalId: r.rule_id });
        if (!upr) {
          return r;
        }
        return {
          ...r,
          ...transformGamUprToUprConfig({
            gamUpr: upr,
          }),
        };
      }),
    };
  }

  render() {
    const { units, virtualPlacements } = this.props;
    const { uprValidationReports, publisherReports } = this.state;

    return (
      <>
        <div className="min-h-screen bg-gray-300 px-4 py-8">
          <div className="rounded-t bg-white p-2 shadow-md">
            <div className="flex py-2">
              <TrendUprImpression
                reports={uprValidationReports}
              ></TrendUprImpression>
            </div>
            <UprValidationTable
              reports={uprValidationReports}
            ></UprValidationTable>
            <div className="my-4" style={{ marginBottom: "600px" }}>
              <div className="font-semibold text-gray-800">Publisher Rules</div>
              <RulesTable
                reports={publisherReports}
                networkId={this.props.networkId}
                units={units}
                virtualPlacements={virtualPlacements}
              ></RulesTable>
            </div>
          </div>
        </div>
      </>
    );
  }
}

class RulesTable extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      popupId: "",
    };

    this.handlePopup = this.handlePopup.bind(this);
  }

  handlePopup(ruleId) {
    this.setState({
      popupId: ruleId,
    });
  }

  render() {
    let { reports, networkId, units, virtualPlacements } = this.props;
    reports = _.orderBy(reports, ["date"], ["desc"]);
    const reportsGroupByDate = _.groupBy(reports, "date");

    const { popupId } = this.state;

    return (
      <table className="border shadow table w-full text-sm">
        <thead className="border-b bg-gray-200 text-xs text-blue-800">
          <tr>
            <th className="border w-1/12 px-4 py-1 text-right">Date</th>
            <th className="border w-2/12 px-4 py-1 text-right">Rule ID</th>
            <th className="border w-3/12 px-4 py-1 text-right">Name</th>
            <th className="border w-1/12 px-4 py-1 text-right">Price</th>
            <th className="border w-2/12 px-4 py-1 text-right">Targeting</th>
            <th className="border w-1/12 px-4 py-1 text-right">Impression</th>
            <th className="border w-1/12 px-4 py-1 text-right">Revenue</th>
            <th className="border w-1/12 px-4 py-1 text-right">eCPM</th>
          </tr>
        </thead>
        <tbody className="bg-white font-mono text-gray-900">
          {reports.map((r, i) => {
            const weekdayAbbr = getWeekdayAbbr(r.date);
            const numOfRulesPerDate = reportsGroupByDate[r.date].length;
            const lastDate = _.get(reports, [i - 1, "date"]);

            return (
              <HighLightRowWrapper
                selected={popupId === `${r.date}-${r.rule_id}`}
                key={`${r.rule_id}-${i}`}
              >
                {r.date !== lastDate && (
                  <td
                    className="whitespace-no-wrap border px-4 py-1 text-right"
                    rowSpan={numOfRulesPerDate}
                  >
                    {i === 0 && <span className="font-bold">*</span>}
                    {r.date} {weekdayAbbr}
                  </td>
                )}

                <td
                  className={`border px-4 py-1 text-right ${
                    popupId === r.rule_id ? "font-semibold" : ""
                  }`}
                >
                  {r.rule_id}
                </td>
                <td
                  className={`border px-4 py-1 text-right ${
                    popupId === r.rule_id ? "font-semibold" : ""
                  }`}
                >
                  {r.name}
                </td>
                <td className="border px-4 py-1 text-right">
                  {r.priceSection ? (
                    <UprPriceSection
                      item={r.priceSection}
                      currency={r.priceSection.currency}
                      networkId={networkId}
                      onOpen={() => this.handlePopup(`${r.date}-${r.rule_id}`)}
                      onClose={() => this.handlePopup("")}
                    ></UprPriceSection>
                  ) : (
                    "--"
                  )}
                </td>
                <td className="border px-4 py-1 text-right">
                  <div>
                    {r.targetingSection && (
                      <UprTargetingPopover
                        id={r.externalId}
                        name={r.name}
                        networkId={networkId}
                        units={units}
                        virtualPlacements={virtualPlacements}
                        targetingSection={r.targetingSection}
                        triggerElement={
                          <div className="inline-block cursor-pointer  text-blue-600 hover:text-blue-700 hover:underline">
                            {Object.keys(r.targetingSection).join(", ")}
                          </div>
                        }
                        onOpen={() =>
                          this.handlePopup(`${r.date}-${r.rule_id}`)
                        }
                        onClose={() => this.handlePopup("")}
                      ></UprTargetingPopover>
                    )}
                  </div>
                </td>

                <td className="border px-4 py-1 text-right">
                  {_.isNumber(r.impression) ? (
                    <NumberFormat
                      value={r.impression}
                      format="0,0"
                    ></NumberFormat>
                  ) : (
                    "-"
                  )}
                </td>

                <td className="border px-4 py-1 text-right">
                  {_.isNumber(r.revenue) ? (
                    <NumberFormat
                      value={r.revenue}
                      format="$0,0.00"
                    ></NumberFormat>
                  ) : (
                    "-"
                  )}
                </td>

                <td className="border px-4 py-1 text-right">
                  {_.isNumber(r.ecpm) ? (
                    <NumberFormat
                      value={r.ecpm}
                      format="$0,0.00"
                    ></NumberFormat>
                  ) : (
                    "-"
                  )}
                </td>
              </HighLightRowWrapper>
            );
          })}
        </tbody>
      </table>
    );
  }
}

class UprValidationTable extends React.PureComponent {
  render() {
    let { reports } = this.props;
    return (
      <table className="border shadow table w-full text-sm">
        <thead className="border-b bg-gray-200 text-xs text-blue-800">
          <tr>
            <th rowSpan="2" className="border px-4 py-1 text-right">
              Date
            </th>
            <th rowSpan="2" className="border px-4 py-1 text-right">
              Optimization Adx Impression
            </th>
            <th colSpan="3" className="border px-4 py-1 text-center">
              Intowow Rule Adx
            </th>
            <th rowSpan="2" className="border px-4 py-1 text-right">
              Imp Ratio
            </th>
          </tr>
          <tr>
            <th className="border px-4 py-1 text-right">Impression</th>
            <th className="border px-4 py-1 text-right">Revenue</th>
            <th className="border px-4 py-1 text-right">eCPM</th>
          </tr>
        </thead>
        <tbody className="bg-white font-mono text-gray-900">
          {reports.map((r, i) => {
            const weekdayAbbr = getWeekdayAbbr(r.date);
            return (
              <tr key={i} className="border-b hover:bg-gray-100">
                <td className="whitespace-no-wrap border px-4 py-1 text-right">
                  {i === 0 && <span className="font-bold">*</span>}
                  {r.date} {weekdayAbbr}
                </td>

                <td className="border px-4 py-1 text-right">
                  {_.isNumber(r.optimizationAdxImpression) ? (
                    <NumberFormat
                      value={r.optimizationAdxImpression}
                      format="0,0"
                    ></NumberFormat>
                  ) : (
                    "-"
                  )}
                </td>

                <td className="border px-4 py-1 text-right">
                  {_.isNumber(r.intowowRuleAdxImpression) ? (
                    <NumberFormat
                      value={r.intowowRuleAdxImpression}
                      format="0,0"
                    ></NumberFormat>
                  ) : (
                    "-"
                  )}
                </td>

                <td className="border px-4 py-1 text-right">
                  {_.isNumber(r.intowowRuleAdxRevenue) ? (
                    <NumberFormat
                      value={r.intowowRuleAdxRevenue}
                      format="$0,0.00"
                    ></NumberFormat>
                  ) : (
                    "-"
                  )}
                </td>

                <td className="border px-4 py-1 text-right">
                  {_.isNumber(r.ecpm) ? (
                    <NumberFormat
                      value={r.ecpm}
                      format="$0,0.00"
                    ></NumberFormat>
                  ) : (
                    "-"
                  )}
                </td>

                <td className="border px-4 py-1 text-right">
                  {_.isNumber(r.impressionRatio) ? (
                    <NumberFormat
                      value={r.impressionRatio}
                      format="0,0.00%"
                    ></NumberFormat>
                  ) : (
                    "-"
                  )}
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>
    );
  }
}

export default UprValidationView;
